import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';

type Variables = {
  spaceId: string;
  name: string;
};

async function updateSpace(spaceId: string, name: string) {
  const { error } = await apiClient
    .from('spaces')
    .update({ name })
    .eq('id', spaceId);

  if (error) {
    throw error;
  }
}

export default function useUpdateSpace() {
  return useMutation({
    mutationFn: ({ spaceId, name }: Variables) => updateSpace(spaceId, name),
    onSuccess: () => {
      enqueueSnackbar('Espace mis à jour.', 'success');
    },
  });
}
